import React, { Component } from 'react';

const AsyncLoading = () => {
  return ''
}

export default AsyncLoading
